export default class Navbar {
    static init(): void {
        this.navbarInit();
    }

    static navbarInit(): void {
        const navbar: HTMLElement | null = document.querySelector('.base-navbar');

        if (!navbar) {
            return;
        }

        this.handleScrollState(navbar);
        this.handleMenuToggle(navbar);
        this.handleDropdowns(navbar);
    }

    static handleScrollState(navbar: HTMLElement): void {
        const update = () => {
            if (window.scrollY > 0) {
                navbar.classList.add('base-navbar--scrolled');
            } else {
                navbar.classList.remove('base-navbar--scrolled');
            }
        };

        update();
        window.addEventListener('scroll', update);
    }

    static handleMenuToggle(navbar: HTMLElement): void {
        const toggle: HTMLElement | null = navbar.querySelector('.base-navbar__toggle');
        const desktop = window.matchMedia('(min-width: 1024px)');

        if (!toggle) {
            return;
        }

        const closeMenu = () => {
            navbar.classList.remove('base-navbar--menu-open');
            toggle.setAttribute('aria-expanded', 'false');
            document.body.classList.remove('body-is-lock');
        };

        toggle.addEventListener('click', () => {
            const isOpen = navbar.classList.toggle('base-navbar--menu-open');
            toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
            document.body.classList.toggle('body-is-lock', isOpen);
        });

        document.addEventListener('keydown', (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
                closeMenu();
            }
        });

        desktop.addEventListener('change', (event: MediaQueryListEvent) => {
            if (event.matches) {
                closeMenu();
            }
        });
    }

    static handleDropdowns(navbar: HTMLElement): void {
        const toggles: NodeListOf<HTMLElement> = navbar.querySelectorAll('.base-navbar__dropdown-toggle');
        // keep in sync with the hover rules in _base-navbar.scss
        const hoverDesktop = window.matchMedia('(hover: hover) and (min-width: 1024px)');

        if (toggles.length === 0) {
            return;
        }

        const closeAll = () => {
            navbar.querySelectorAll('.base-navbar__item--dropdown-open').forEach((item) => {
                item.classList.remove('base-navbar__item--dropdown-open');
            });
            toggles.forEach((toggle) => {
                toggle.setAttribute('aria-expanded', 'false');
            });
        };

        toggles.forEach((toggle) => {
            const item: HTMLElement | null = toggle.closest('.base-navbar__item');

            if (!item) {
                return;
            }

            toggle.addEventListener('click', (event: MouseEvent) => {
                // desktop with a mouse opens the submenu on hover (CSS), so a link toggle
                // just navigates; touch screens and the mobile menu toggle it on tap instead
                if (toggle instanceof HTMLAnchorElement && hoverDesktop.matches) {
                    return;
                }

                event.preventDefault();
                event.stopPropagation();
                const isOpen = item.classList.contains('base-navbar__item--dropdown-open');
                closeAll();

                if (!isOpen) {
                    item.classList.add('base-navbar__item--dropdown-open');
                    toggle.setAttribute('aria-expanded', 'true');
                }
            });
        });

        document.addEventListener('click', (event: MouseEvent) => {
            if (!(event.target instanceof Node) || !navbar.contains(event.target)) {
                closeAll();
            }
        });

        document.addEventListener('keydown', (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
                closeAll();
            }
        });
    }
}
